import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=336f6618&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('336f6618')) {
      api.createRecord('336f6618', component.options)
    } else {
      api.reload('336f6618', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=336f6618&", function () {
      api.rerender('336f6618', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2GhxtgWr5BMSO/JS/comp/childrenage.vue"
export default component.exports